var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.673.555H3.423A3.367 3.367 0 00.055 3.922v18.25a3.367 3.367 0 003.366 3.367h9.001l.016-8.928h-2.32a.547.547 0 01-.547-.545l-.011-2.878a.547.547 0 01.547-.549h2.315v-2.78c0-3.228 1.971-4.985 4.85-4.985h2.362c.302 0 .547.245.547.548v2.426a.547.547 0 01-.547.547l-1.45.001c-1.565 0-1.868.744-1.868 1.836v2.407h3.44c.328 0 .582.286.544.612l-.341 2.878a.547.547 0 01-.544.482h-3.084l-.015 8.928h5.356a3.367 3.367 0 003.367-3.366V3.923A3.367 3.367 0 0021.672.554z",
    fill: "url(#fb-icon_svg__paint0_linear_6101_35787)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.673.555H3.423A3.367 3.367 0 00.055 3.922v18.25a3.367 3.367 0 003.366 3.367h9.001l.016-8.928h-2.32a.547.547 0 01-.547-.545l-.011-2.878a.547.547 0 01.547-.549h2.315v-2.78c0-3.228 1.971-4.985 4.85-4.985h2.362c.302 0 .547.245.547.548v2.426a.547.547 0 01-.547.547l-1.45.001c-1.565 0-1.868.744-1.868 1.836v2.407h3.44c.328 0 .582.286.544.612l-.341 2.878a.547.547 0 01-.544.482h-3.084l-.015 8.928h5.356a3.367 3.367 0 003.367-3.366V3.923A3.367 3.367 0 0021.672.554z",
    fill: "url(#fb-icon_svg__paint1_linear_6101_35787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-icon_svg__paint0_linear_6101_35787",
    x1: 25.538,
    y1: 0.785,
    x2: 0.29,
    y2: 26.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-icon_svg__paint1_linear_6101_35787",
    x1: 24.984,
    y1: 0.611,
    x2: 0.111,
    y2: 25.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })))));
}

export default __webpack_public_path__ + "./fonts/fb-icon.7f1befe7e5518041539a685291e3dc7f.svg";
export { SvgFbIcon as ReactComponent };